import { render, staticRenderFns } from "./JiraApiTokenDialog.vue?vue&type=template&id=56a8ce1a"
import script from "./JiraApiTokenDialog.vue?vue&type=script&lang=js"
export * from "./JiraApiTokenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports